import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-holiday-type',
  templateUrl: './holiday-type.component.html',
  styleUrls: ['./holiday-type.component.css']
})
export class HolidayTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
